export default __webpack_public_path__ + "Lost-in-Space.png";